<div class="tw-relative tw-bg-white tw-rounded-t-3xl tw-overflow-hidden">
  <div class="tw-absolute  tw-flex tw-justify-center tw-items-center tw-z-[100] tw-w-8 tw-h-8 tw-top-3 tw-right-5 tw-bg-white tw-rounded-full" (click)="dismiss()">
    <cs-icon class="tw-w-3 tw-h-4" iconName="bottomsheet_close_rounded" style="color: #616161;"></cs-icon>
  </div>
  <!-- Header illustration with wave border -->
  <div class="tw-flex tw-items-center tw-justify-center">
    <img
      src="/assets/images/shiprocket/prefill_address_bottomsheet.png"
      class="tw-object-contain"
      alt="Shipping illustration"
    />
  </div>

  <!-- Content -->
  <div class="tw-px-5 tw-pt-4 tw-pb-11 tw-text-center">
    <h3 class="tw-font-lexend tw-font-semibold tw-text-400 tw-text-gray-900 tw-m-0 tw-mb-1" i18n="@@shiprocketFillAddressTitle">
      We can help fill your address
    </h3>
    <p class="tw-font-noto tw-text-200 tw-text-gray-500 tw-m-0 tw-whitespace-pre-line" i18n="@@shiprocketFillAddressSubtitle">
      Get your saved address <br /> filled automatically or add manually
    </p>
  
    <div class="tw-flex tw-justify-center tw-mb-5">
      <img
        src="/assets/icons/poweredByShipRocket.png"
        class="tw-max-w-24"
        style="mix-blend-mode: multiply;"
        alt="Powered by Shiprocket"
      />
    </div>

    <!-- CTA Buttons -->
    <div class="tw-flex tw-gap-3 tw-justify-center">
      <button
        type="button"
        csButton="outlined"
        class="tw-flex-1 tw-text-300 tw-font-semibold tw-h-10"
        (click)="onAddManually()"
        i18n="@@shiprocketAddManually"
      >Add Manually</button>
      <button
        type="button"
        csButton
        class="tw-flex-1 tw-text-300 tw-font-semibold tw-h-10"
        (click)="onGetAddress()"
        i18n="@@shiprocketGetAddress"
      >Get Address</button>
    </div>
  </div>
</div>
